import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AzureMarketplaceErrorComponent } from './components/azure-marketplace-error/azure-marketplace-error.component'
import { AzureMarketplaceComponent } from './components/azure-marketplace/azure-marketplace.component'
import { AzureMarketplaceSelectLinkedAccountComponent } from './components/azure-marketplace-select-linked-account/azure-marketplace-select-linked-account.component'

const routes: Routes = [
  {
    path: 'azure_marketplace',
    component: AzureMarketplaceComponent,
  },
  {
    path: 'azure_marketplace/link_account',
    component: AzureMarketplaceSelectLinkedAccountComponent,
  },
  {
    path: 'azure_marketplace/error',
    component: AzureMarketplaceErrorComponent,
  },
]

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
})
export class AzureMarketplaceRoutingModule {}
